import styled, { css } from "styled-components";
import { Layers } from "react-bootstrap-icons";

const MapSettingButtonStyles = css`
  z-index: 1;
  position: absolute;
  top: 14px;
  right: 15px;
`;

export const BlockLabelAxe = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 3px 8px 3px;
`;

export const LabelAxe = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  color: ${({ theme }) => theme.neutralText};
`;

export const HeadingNameAndButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;


export const DatavizRecommendedCount = styled.div`
  font-size: 11px;
 line-height: 14px;
  font-weight: 400;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background-color: ${({ theme }) => theme.primaryAction};
  color: ${({ theme }) => theme.primaryTextStrong};
  border-radius: 2px;
`;

export const DatavizSettingsIcon = styled(Layers)`
  fill: ${({ theme }) => theme.neutralTextWeak};
  transition: 0.3s;
`;

export const SettingsButtonWrapper = styled.div<{
  $map?: boolean;
  $modalOpen?: boolean;
}>`
  transition: 0.3s;
  display: ${({ $modalOpen }) => ($modalOpen ? "none" : "flex")};
  gap: 4px;
  align-items: center;
  padding: 2px 4px 2px 2px;
  border: 1px solid ${({ theme }) => theme.neutralBorder};
  border-radius: 4px;
  cursor: pointer;
  background: ${({ theme }) => theme.neutralBackgroundActive};
  ${({ $map }) => $map && MapSettingButtonStyles}
  
  &:hover{
    background: ${({ theme }) => theme.primaryBackgroundMedium};
    ${DatavizSettingsIcon} {
      fill: ${({ theme }) => theme.neutralText};
    }
  }

  &:active{
    background: ${({ theme }) => theme.primaryBackgroundActive};
    ${DatavizSettingsIcon} {
      fill: ${({ theme }) => theme.primaryText};
    }
  }
`;